import React from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'next-i18next';

interface ErrorStateProps {
  isApiError: boolean;
  fallbackToMockData: boolean;
  showApiErrorMessage: boolean;
  apiError?: Error | null;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  isApiError,
  fallbackToMockData,
  showApiErrorMessage,
  apiError,
}) => {
  const { t } = useTranslation('common');
  
  if (!isApiError || (!showApiErrorMessage && fallbackToMockData)) return null;

  return (
    <div style={{ padding: '16px', borderBottom: '1px solid #f0f0f0' }}>
      {!fallbackToMockData ? (
        <Alert severity="warning">
          {t('api_error_loading_filters')}: {apiError?.message}
        </Alert>
      ) : showApiErrorMessage ? (
        <Alert severity="info">
          {t('api_fallback_basic_filters')}
        </Alert>
      ) : null}
    </div>
  );
}; 